import { render, staticRenderFns } from "./CancelGroupConsent.vue?vue&type=template&id=5232f062&scoped=true&"
import script from "./CancelGroupConsent.vue?vue&type=script&lang=js&"
export * from "./CancelGroupConsent.vue?vue&type=script&lang=js&"
import style0 from "./CancelGroupConsent.vue?vue&type=style&index=0&id=5232f062&prod&lang=css&"
import style1 from "./CancelGroupConsent.vue?vue&type=style&index=1&id=5232f062&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232f062",
  null
  
)

export default component.exports